function checkAbholung() {
    var cookie = Cookies.get('filiale')
    if (cookie === 'online') return;
    var cookieJson = {};
    try {
        cookieJson = JSON.parse(cookie);
    } catch (e) {
    }

    if (cookieJson.itemName) {
        $('#safe').detach();
        $('.payimg').detach();
    }
}


$(document).ready(function () {
    let $ = window.jQuery;

    let maxDate;
    let minDate;

    if (new Date() >= new Date('2020-12-07')) {
        if (new Date() < new Date('2020-12-19')) {
            maxDate = new Date('2020-12-18')
            minDate = 1
        } else if (new Date() < new Date('2020-12-25')) {
            maxDate = 30
            minDate = new Date('2020-12-25')
        } else {
            maxDate = 30
            if (new Date().getHours() >= 14)
                minDate = 2
            else
                minDate = 1
        }
    } else {
        maxDate = new Date('2020-12-24')
        minDate = 1
    }

    $(function () {
        $("#pickup-date").datepicker({
            minDate: minDate,
            maxDate: maxDate,
            beforeShowDay: $.datepicker.noSundaysAndHolidays,
            closeText: 'Schließen', // set a close button text
            currentText: 'Heute', // set today text
            monthNames: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'], // set month names
            monthNamesShort: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'], // set short month names
            dayNames: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'], // set days names
            dayNamesShort: ['Son', 'Mon', 'Din', 'Mit', 'Don', 'Fre', 'Sam'], // set short day names
            dayNamesMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'], // set more short days names
            firstDay: 1,
            dateFormat: 'dd.mm.yy'
        });
    });
})

$(document).ready(function () {
    var cookie = Cookies.get('filiale');

    if (cookie === 'online') {
        return;
    }

    var cookieJson = {};
    try {
        cookieJson = JSON.parse(cookie);
    } catch (exceptions) {
    }

    if (cookieJson.itemName) {
        $('#pickup-store').val(cookieJson.itemName);
        $('#filialespan').text(cookieJson.itemName);
        $('#pickup-storecode').val(cookieJson.code);
    }


})



$('.qtybox .btnqty').on('click', function(){
    var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
    if($(this).hasClass('qtyplus')) {
        qty++;
    }else {
        if(qty > 1) {
            qty--;
        }
    }
    qty = (isNaN(qty))?1:qty;
    $(this).parent('.qtybox').find('.quantity-input').val(qty);
});